import { API_ENDPOINT } from '@/actions/utils/api-client/api-endpoint'
import { handleActionRequest } from '@/actions/utils/handle-action-request'
import {
  List,
  apiListResponseSchema,
  APIResponse,
} from '@/schemas/api-response'
import { Product, productSchema } from '@/schemas/product'
import { ProductsQueryType } from '@/schemas/product/products-query'

export const getProductsAction = async ({
  query,
}: {
  query: ProductsQueryType
}): Promise<APIResponse<List<Product>>> => {
  return handleActionRequest({
    endpoint: API_ENDPOINT.products.getProducts({ ...query }),
    schema: apiListResponseSchema(productSchema),
  })
}
